import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Table, TextLink} from "components";
import {cSubscriptionAction} from "redux/actions";
import {useHistory, useParams, useRouteMatch} from "react-router-dom";

export default function ToDo() {
    // Routers
    const {
        push,
        location: {pathname}
    } = useHistory();

    const currentLocation = pathname.split("/", 4)[3];

    // States
    const [tableRows, setTableRows] = useState();

    // Redux actions
    const dispatch = useDispatch();
    const cSubscription = useSelector(state => state.cSubscription);

    useEffect(() => {
        dispatch(cSubscriptionAction.get(currentLocation, 1));
        return () => dispatch(cSubscriptionAction.reset());
    }, []);

    useEffect(() => {
        let filtered = cSubscription?.subscriptions;

        if (!filtered?.length) {
            setTableRows();
            return;
        }

        // Map table rows
        const data = filtered?.map(obj => ({
            id: (
                <TextLink
                    text={obj?.id}
                    onClick={() => {
                        push(
                            `/customers/customers/${obj?.id}/${currentLocation}/subscription-modal`
                        );
                    }}
                />
            ),
            cartID: (
                <TextLink
                    text={obj?.cartID}
                    onClick={() => push(`/orders/orders?orderID=${obj?.cartID}`)}
                />
            ),
            status: obj?.status,
            dateTime: `${obj?.serviceDate}, ${obj?.serviceTime}`,
            reschedCount: obj?.reschedCount,
            createdAt: `${new Date(obj?.createdAt).toLocaleString()}`,
            updatedAt: `${new Date(obj?.updatedAt).toLocaleString()}`
        }));

        setTableRows(data);
    }, [cSubscription]);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Subscription"
            },
            {
                title: "Order"
            },
            {
                title: "Status"
            },
            {
                title: "Date/Time"
            },
            {
                title: "ReScheduled Count"
            },
            {
                title: "Created"
            },
            {
                title: "Updated"
            }
        ],
        [tableRows]
    );

    return (
        <>
            <Table
                headers={tableHeaders}
                data={tableRows}
                current={cSubscription?.currentPage}
                totalPage={cSubscription?.maxPages}
                onPageChange={pageNumber => {
                    dispatch(cSubscriptionAction.get(currentLocation, pageNumber));
                }}
            />
        </>
    );
}
